export const DEFAULT_CURRENCY_CODE = "usd";
export const DEFAULT_CURRENCY_SYMBOL = "$";

const currencyCodeToSymbolMap: Record<string, string> = {
  usd: "$",
  cad: "$",
  eur: "€",
  gbp: "£",
};

export const convertCurrencyCodeToSymbol = (
  currencyCode: string | null | undefined
): string => {
  if (typeof currencyCode !== "string") {
    return currencyCodeToSymbolMap[DEFAULT_CURRENCY_CODE];
  }

  const normalizedCurrencyCode = currencyCode.toLowerCase();

  return (
    currencyCodeToSymbolMap[normalizedCurrencyCode] ??
    currencyCodeToSymbolMap[DEFAULT_CURRENCY_CODE]
  );
};
